/* V2
 Builds a table header, adds base-name to the css classes for customized css
 */

import * as React from "react"
import {map as _map} from "lodash";

export interface ITemplatedListHeader {
    display: string,
    textSize: string
}

interface TemplatedListHeadersProps {
    headersInfo: ITemplatedListHeader[],
}

class TemplatedListHeaders extends React.Component<TemplatedListHeadersProps> {

    render() {
        return <div>
            {
                _map(this.props.headersInfo, (headerInfo, index) => {
                    return (
                        <div className={`smart-column brandon-bold ${headerInfo.textSize} right-margin`}
                            key={index}>
                            {headerInfo.display}
                        </div>
                    )
                })
            }
        </div>
    }
}

export default TemplatedListHeaders;